// extracted by mini-css-extract-plugin
module.exports = {"style_select":"style_style_select__1ibD_","style_menu":"style_style_menu__10_Rv"};